import React, { useState, useCallback } from 'react';
import BadgesComponent from '@components/common/Badges';
import DataTable from '@components/common/CommonDataTable';
import './HealthProviderOverview.css';
import { approvalConstantData, STATUS } from '@constants/approvalConstants';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { formatDate } from '@fullcalendar/core';
import dayjs from 'dayjs';

interface CurrentDetailsViewProps {
  healthProviderCurrentDetails?: any;
}

const CurrentDetailsView: React.FC<CurrentDetailsViewProps> = ({
  healthProviderCurrentDetails,
}) => {

  const approvalLayout = useSelector((state: RootState) => state.approvalWorkFlow);
  const userDetails = (healthProviderCurrentDetails?.current_data?.user_details && Array.isArray(healthProviderCurrentDetails?.current_data?.user_details) && healthProviderCurrentDetails?.current_data?.user_details.length > 0) ? healthProviderCurrentDetails?.current_data?.user_details[0] : {};
  const locationDetails = healthProviderCurrentDetails?.current_data?.location_details || {};
  const facilityDetails = locationDetails?.facility_details || {};
  const effectiveFromDate = healthProviderCurrentDetails?.effective_from_date
  const healthProviders = Array.isArray(locationDetails?.health_provider_details) ? locationDetails.health_provider_details : [];
  const linkedVillages = Array.isArray(locationDetails?.linked_village) ? locationDetails.linked_village : [];
  const linkedWards = Array.isArray(locationDetails?.linked_ward) ? locationDetails.linked_ward : [];
  const linkedGramPanchayats = Array.isArray(locationDetails?.linked_gram_panchayat) ? locationDetails.linked_gram_panchayat : [];

  const getHealthProviderNames = () => {
    if (healthProviders.length === 0) return '-';
    return healthProviders.map((provider: any) => provider.health_provider_name).filter((name: any) => name).join(', ');
  };

  const getMobiliserDetails = () => {
    const mobiliserDetails = locationDetails?.mobiliser_details;
    if (!mobiliserDetails || !Array.isArray(mobiliserDetails) || mobiliserDetails.length === 0) return '-';
    return mobiliserDetails.map(mobiliser => mobiliser.mobiliser_name).filter(name => name).join(', ');
  };

  const getLinkedVillageNames = () => {
    if (linkedVillages.length === 0) return '-';
    return linkedVillages.map((village: any) => village.linked_village_name).filter((name: any) => name).join(', ');
  };

  const getLinkedWardNames = () => {
    if (linkedWards.length === 0) return '-';
    return linkedWards.map((ward: any) => ward.linked_ward_name).filter((name: any) => name).join(', ');
  };

  const getLinkedGramPanchayatNames = () => {
    if (linkedGramPanchayats.length === 0) return '-';
    return linkedGramPanchayats.map((gp: any) => gp.linked_gram_panchayat_name).filter((name: any) => name).join(', ');
  };

  return (
    <div className="current-details-view">
      <div className="overview_user">
        {(approvalLayout.requestData.requestFor == approvalConstantData.requestFor.sent) && <div className="overview-details" style={{ margin: '0 0 20px 0' }}>
          <div>
            <label className="overview-details-label">Approver Comment</label>
            <div className="overview-details-value">{approvalLayout.requestData.requestComments ? approvalLayout.requestData.requestComments : '-'}</div>
          </div>
        </div>}
        <BadgesComponent
          className="over-badge"
          badgeName="Hierarchy Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details">
          <div>
            <label className="overview-details-label">User Name</label>
            <div className="overview-details-value">{userDetails?.user_name ? userDetails.user_name : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">Mobile Number</label>
            <div className="overview-details-value">{userDetails?.mobile_number ? userDetails.mobile_number : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">User Status</label>
            <div className="overview-details-value">{userDetails?.user_status ? userDetails.user_status : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">User Type</label>
            <div className="overview-details-value">{userDetails?.user_type ? userDetails.user_type : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">Designation</label>
            <div className="overview-details-value">{userDetails?.user_designation ? userDetails.user_designation : '-'}</div>
          </div>

          <div>
            <label className="overview-details-label">State</label>
            <div className="overview-details-value">{locationDetails?.state?.state_name ? locationDetails.state?.state_name : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">District</label>
            <div className="overview-details-value">{locationDetails?.district?.district_name ? locationDetails.district?.district_name : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">Sub-District</label>
            <div className="overview-details-value">{locationDetails?.sub_district?.sub_district_name ? locationDetails.sub_district?.sub_district_name : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">Block</label>
            <div className="overview-details-value">{locationDetails?.block?.block_name ? locationDetails.block?.block_name : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">Health Block</label>
            <div className="overview-details-value">{locationDetails?.health_block?.health_block_name ? locationDetails.health_block?.health_block_name : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">Sub-Division</label>
            <div className="overview-details-value">{locationDetails?.sub_division?.sub_division_name ? locationDetails.sub_division?.sub_division_name : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">ULB</label>
            <div className="overview-details-value">{locationDetails?.ulb?.ulb_name ? locationDetails.ulb?.ulb_name : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">Rural/Urban</label>
            <div className="overview-details-value">{locationDetails?.urban_rual?.urban_rural_name ? locationDetails.urban_rual?.urban_rural_name : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">Village</label>
            <div className="overview-details-value">{locationDetails?.village?.village_name ? locationDetails.village?.village_name : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">Ward</label>
            <div className="overview-details-value">{locationDetails?.ward?.ward_name ? locationDetails.ward?.ward_name : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">Gram Panchayat</label>
            <div className="overview-details-value">{locationDetails?.gram_panchayat?.gram_panchayat_name ? locationDetails.gram_panchayat?.gram_panchayat_name : '-'}</div>
          </div>
        </div>
        <div className="overview_user">
          <BadgesComponent
            className="over-badge"
            badgeName="Coverage Details"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="overview-details">
            <div>
              <label className="overview-details-label">Facility Name</label>
              <div className="overview-details-value">{facilityDetails.facility_name ? facilityDetails.facility_name : '-'}</div>
            </div>
            <div>
              <label className="overview-details-label">Facility Type</label>
              <div className="overview-details-value">{facilityDetails.facility_type_name ? facilityDetails.facility_type_name : '-'}</div>
            </div>
            <div>
              <label className="overview-details-label">HFR ID</label>
              <div className="overview-details-value">{facilityDetails.hfr_id ? facilityDetails.hfr_id : '-'}</div>
            </div>
            <div>
              <label className="overview-details-label">Effective From Date</label>
              <div className="overview-details-value">{effectiveFromDate ? dayjs(effectiveFromDate).format('DD-MM-YYYY') : '-'}</div>
            </div>
            <div>
              <label className="overview-details-label">Health Provider Details</label>
              <div className="overview-details-value">{getHealthProviderNames()}</div>
            </div>
            <div>
              <label className="overview-details-label">Mobiliser Details</label>
              <div className="overview-details-value">{getMobiliserDetails()}</div>
            </div>
            <div>
              <label className="overview-details-label">Linked Villages</label>
              <div className="overview-details-value">{getLinkedVillageNames()}</div>
            </div>
            <div>
              <label className="overview-details-label">Linked Wards</label>
              <div className="overview-details-value">{getLinkedWardNames()}</div>
            </div>
            <div>
              <label className="overview-details-label">Linked Gram Panchayat</label>
              <div className="overview-details-value">{getLinkedGramPanchayatNames()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentDetailsView;
